module.exports = __webpack_public_path__ + "static/iStock_000037546596_Large.319b0539.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/iStock_000037546596_Large.jpg
// module id = 808
// module chunks = 263791100135453